import { Star } from "lucide-react";

export const renderStars = (rating: number) => {
  return (
    <div className="flex items-center space-x-1">
      {Array.from({ length: 5 }, (_, i) => {
        const starValue = i + 1;
        const fillPercent = Math.min(Math.max(rating - i, 0), 1) * 100;
        // 0 → empty, 100 → full, 40 → 40% filled

        return (
          <div key={i} className="relative h-4 w-4">
            {/* gray background star */}
            <Star className="h-4 w-4 text-gray-300 absolute" />
            {/* yellow overlay star clipped by percentage */}
            <div
              className="absolute top-0 left-0 overflow-hidden"
              style={{ width: `${fillPercent}%` }}
            >
              <Star className="h-4 w-4 text-yellow-400 fill-current" />
            </div>
          </div>
        );
      })}
      {rating && (
        <span className="ml-2 text-xs text-muted-foreground">
          ({rating.toFixed(1)})
        </span>
      )}
    </div>
  );
};
